import store from '@/store/store'
import Visibility from 'visibilityjs'

Visibility.change((_, state) => {
  store.commit('ui/setPageIsVisible', state === 'visible')
})
